declare global {
  interface Window {
    ENV?: Record<string, string> | string;
  }
}

const loadConfigFromEnvDev = import.meta.env.DEV
  ? function () {
      return {
        API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
        PUSHER_APP_KEY: import.meta.env.VITE_PUSHER_APP_KEY,
        ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
      };
    }
  : null;

const NOT_SET = 'NOT_SET';
const CONFIG_PATH = '/xiQgmYgQIb';

class ConfigService {
  public config: {
    API_BASE_URL: string;
    PUSHER_APP_KEY: string;
    ENVIRONMENT: string;
  };

  constructor() {
    this.config = {
      API_BASE_URL: NOT_SET,
      PUSHER_APP_KEY: NOT_SET,
      ENVIRONMENT: NOT_SET,
    };
  }

  async loadConfig() {
    if (import.meta.env.DEV) {
      this.loadConfigFromEnv();
    } else {
      await this.loadConfigFromJson();
    }
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.log('DEV_ONLY__LOADED_CONFIG', this.config);
    }
    this.validateConfig();
  }

  loadConfigFromEnv() {
    if (loadConfigFromEnvDev) {
      const config = loadConfigFromEnvDev();
      this.config = { ...this.config, ...config };
    }
  }

  async loadConfigFromJson() {
    try {
      const response = await fetch(CONFIG_PATH);
      const base64Content = await response.text();
      if (base64Content) {
        try {
          const decoded = atob(base64Content.trim());
          const envConfig = JSON.parse(decoded);
          this.config = { ...this.config, ...envConfig };
        } catch (decodeError) {
          // eslint-disable-next-line no-console
          console.error('Failed to decode base64 configuration:', decodeError);
        }
      } else {
        // eslint-disable-next-line no-console
        console.warn('Empty configuration file');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Failed to load runtime config', error);
    }
  }

  get(key: keyof ConfigService['config']) {
    return this.config[key];
  }

  validateConfig() {
    Object.entries(this.config).forEach(([key, value]) => {
      if (value === NOT_SET || value === '') {
        // eslint-disable-next-line no-console
        console.warn(`Missing config: ${key}`);
      }
    });
  }
}

export default new ConfigService();
